import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../baseClasses/BaseComponent'; 
import Arrow from '../../../../assets/images/arrow-button.svg';
import buildIconGray from '../../../../assets/images/build-icon-gray.svg';
import taskIconGray from '../../../../assets/images/task-icon-gray.svg';
import PopupMenu from '../../../../components/PopupMenu';
import UserAvatar from '../../../../components/UserAvatar';
import SelectUserComboBox from '../../../../components/SelectUserComboBox';
import ComboBox from '../../../../components/ComboBox';
import dataModel from '../../../../models/DataModel';
import { build_card } from '../../../../dao/BuildsDAO';
import LoadingDots from '../../../../components/LoadingDots';
import * as BuildOwnerPermissionsUtil from '../../../../helpers/permissions/BuildOwnerPermissionsUtil';
import DataSource from '../../../../dao/DataSource/DataSource';
import LocationsCollection from '../../../../dao/collections/LocationsCollection';
import { location_shallow } from '../../../../dao/collections/LocationsCollection';
import './BuildDetailCard.scss';
import CopyBuildPopout from '../../../../components/CopyBuildPopout';
import Input from '../../../../components/Input';

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

class BuildDetailCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
      menu: null, 
      openEditOptions: false,
      currentBuildOwners: [],
      currentBuildNotify: [],
      bulkAssignSelected: props.bulkAssignSelected,
      bulkAssignDisabled: false,
      loadingLocations: null,
      locations: null,
      totalLocation: null,
      locationsList: null,
      currentMarketId: null,
      displayCopyPopout: false,
    };
    this.doDeleteBuild = this.doDeleteBuild.bind(this);
    this.handleCopyPopupOpen = this.handleCopyPopupOpen.bind(this);
    this.handleCopyPopupClose = this.handleCopyPopupClose.bind(this);
  }
  
  handleBuildRetrieval(build, action, acData, fetchedData) {
    if (acData) {
      this.setState({ build: fetchedData });
    }
    else {
      if (action == 'update') {
        this.setState({ build }, () => {
          this.handleEditCancel();
        });
      }
      else if (build) {
        this.setState({ build });
        if (this.props.quickAssignments) {
          if (this.props.quickAssignments['build-notify']) {
            const selectedUserAssignment = build.user_build_assignments.find(uba => {
              if (uba.assignment_type == 'notify' && this.props.quickAssignments['build-notify'][uba.user_id]) {
                return uba;
              }
              return false;
            });
            if (selectedUserAssignment) {
              // this.setState({ bulkAssignDisabled: true })
            }
          }
          else if (this.props.quickAssignments['build-owner']
            && build.build_owners.find(user => this.props.quickAssignments['build-owner'][user.id])) {
            // this.setState({ bulkAssignDisabled: true })
          }
        }
      }
    }
  }

  componentDidMount() {
    super.componentDidMount(this);
    if (this.titleInput) {
      this.titleInput.focus();
    }

    if (!this.props.buildId >= 0) {
      this.buildDataSource = new DataSource('Build', this.props.buildId, build_card, this.handleBuildRetrieval);
      this.buildDataSource.get();
    }

    const createLocationList =  this.createLocationOptions();
    this.setState({ locationsList: createLocationList }); 
  }

  componentWillUnmount() {
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.bulkAssignSelected != this.props.bulkAssignSelected) {
      this.setState({ bulkAssignSelected: this.props.bulkAssignSelected });
    }
    if (prevProps.buildId != this.props.buildId) {
      if (this.buildDataSource) {
        this.buildDataSource.release();
      }
      this.buildDataSource = new DataSource('Build', this.props.buildId, build_card, this.handleBuildRetrieval);
      this.buildDataSource.get();
    }
    if (prevState.locations !== this.state.locations) {
      const createLocationList = this.createLocationOptions();
      this.setState({ locationsList: createLocationList });
    }
    if(prevProps.project.builds_count != this.props.project.builds_count){
      this.buildDataSource.get();
    }
  }

  handleCloseMenu() {
    if (this.state.menu) {
      this.setState({ menu: null });
    }
  }

  get isBuildOwner() {
    return this.state.build && this.state.build.build_owners && this.state.build.build_owners.filter(bowner => { return this.props.currentUser.id == bowner.id; });
  }

  doDeleteBuild() {
    dataModel.buildsDAO.deleteBuild(this.state.build.id).then(() => {
      if (this.props.onDeleteBuild) {
        this.props.onDeleteBuild();
      }
    });
  }

  queryDeleteBuild() {
    let message = this.textMap.buildDeleteQuestion;
    
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      cancelButtonText: this.textMap.cancel, 
      okButtonText: this.textMap.deleteBuild,
      width: 300, 
      height: 175, 
      message: message,
      handleOwnerOk: () => {
        this.doDeleteBuild();
      }, 
    });
  }

  handleEditBuild() {
    let editedBuild = _.cloneDeep(this.state.build);
    this.setState({
      editBuild: editedBuild,
      currentBuildOwners: [...editedBuild.build_owners],
      currentBuildNotify: editedBuild.user_build_assignments &&
        editedBuild.user_build_assignments.filter(ba => { return ba.assignment_type == 'notify'; }).map(ba => { return ba.user; }),
    });
    this.getLocations();
    this.props.handleEditBuild(editedBuild, true);
  }

  handleCopyPopupOpen() {
    this.setState({ displayCopyPopout: true });
  }
  
  handleCopyPopupClose() {
    this.setState({ displayCopyPopout: false });
  }

  handleMenuSelection(type) {
    switch (type) {
    case 'delete':
      this.queryDeleteBuild();
      break;
    case 'edit':
      this.handleEditBuild();
      break;
    case 'copy':
      this.handleCopyPopupOpen();
      break;
    default:
      break;
    }
  }
  
  handleBuildSelection(select) {
    const { selectBuild } = this.props;
    const { build } = this.state;
    if (this.props.quickAssignments && !this.state.bulkAssignDisabled) {
      selectBuild(build, this.state.bulkAssignSelected);
      this.setState({ bulkAssignSelected: !this.state.bulkAssignSelected });
    }
    else if (!this.state.editBuild && !this.props.quickAssignments && !this.dragging && !this.state.menu) {
      if (selectBuild) {
        // Null will deselect any currently selected build
        dataModel.buildsDAO.setBreadCrumbs(null);
        selectBuild(build, this.props.project ? this.props.project : this.props.project_template);
      }
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleBuildUpdate();
    }
    else if (e.keyCode == 27) {
      this.handleEditCancel();
    }
  }

  handleExpandClick(e) {
    e.stopPropagation();
    const { handleBuildExpand } = this.props;
    if (handleBuildExpand) {
      handleBuildExpand(this.state.build);
    }
  }

  handleAssignUsers() {
    const { handleBuildAssignUser } = this.props;
    const { build } = this.state;
    if (handleBuildAssignUser) {
      const element = document.getElementById('build-card-' + build.id);
      const rect = element.getBoundingClientRect();
      const left = rect.left;
      const top = rect.top + 80;
      handleBuildAssignUser(build, left, top);
    }
    
  }

  createMoreMenu() {
    let menuOptions = [];
    menuOptions.push({
      type: 'edit',
      name: this.textMap.editBuild,
    });
    menuOptions.push({
      type: 'copy',
      name: 'Copy',
    });
    if (this.props.permissions.canEditProject || this.props.permissions.canDeleteBuild) {
      menuOptions.push({
        type: 'delete',
        name: this.textMap.deleteBuild,
      });
    }

    let left = 335;
    const element = document.getElementById('menu-' + this.state.build.id);
    if (element) {
      const rect = element.getBoundingClientRect();
      const parentRect = element.parentElement.getBoundingClientRect();
      left = (rect.left - parentRect.left) + rect.width + 15;
    }
    const menu = <PopupMenu left={left + 15} top={118} width={150} menuOptions={menuOptions} size="smaller"
      menuId="projectMenu" popupOnHover={false} handleMenuSelection={this.handleMenuSelection}
      handleClickAway={this.handleCloseMenu} pointerPosition="left" />;
    return menu;
  }

  handleMoreButton(e) {
    e.stopPropagation();
    if (!this.state.menu) {
      const menu = this.createMoreMenu();
      this.setState({ menu: menu });
    }
    else {
      this.setState({ menu: null });
    }
  }

  handleNameChange(e) {
    if(e.target.value.trim() !== '' || !e.target.value){
      const editedBuild = Object.assign({}, this.state.editBuild, { name: e.target.value });
      this.setState({ editBuild: editedBuild, nameChanged: e.target.value && e.target.value != this.state.build.name  });
      dataModel.dataChanged = (e.target.value && e.target.value != '') || this.state.locationChanged || this.state.userAssignmentsChanged;
    }
  }

  handleBuildUpdate() {
    if (this.state.editBuild) { 
      if (this.state.userAssignmentsChanged) {
        let userBuildAssignments = [];

        // Find the deletions first

        this.state.editBuild.user_build_assignments.forEach(uba => {
          if (uba.assignment_type == 'build_owner') {
            if (!this.state.currentBuildOwners.find(cbo => { return cbo.id == uba.user.id; })) {
              userBuildAssignments.push({
                id: uba.id,
                user: uba.user,
                user_id: uba.user.id,
                toBeDeleted: true,
                assignment_type: 'build_owner',
              });
            }
          }
          if (uba.assignment_type == 'notify') {
            if (!this.state.currentBuildNotify.find(cbn => { return cbn.id == uba.user.id; })) {
              userBuildAssignments.push({
                id: uba.id,
                user: uba.user,
                user_id: uba.user.id,
                toBeDeleted: true,
                assignment_type: 'notify',
              });
            }
          }
        });

         // Now create the added ones
        
        this.state.currentBuildOwners.forEach(bo => {
          if (!this.state.editBuild.user_build_assignments.find(uba => { return uba.user.id == bo.id && uba.assignment_type == 'build_owner'; })) {
            userBuildAssignments.push({
              user: bo,
              user_id: bo.id,
              toBeAdded: true,
              assignment_type: 'build_owner',
            });
          }
        });
        
        this.state.currentBuildNotify.forEach(bo => {
          if (!this.state.editBuild.user_build_assignments.find(uba => { return uba.user.id == bo.id && uba.assignment_type == 'notify'; })) {
            userBuildAssignments.push({
              user: bo,
              user_id: bo.id,
              toBeAdded: true,
              assignment_type: 'notify',
            });
          }
        });

        this.props.updateBuildAssignments(this.state.editBuild, this.props.project, userBuildAssignments);
      }

      let editedBuild = _.cloneDeep(this.state.editBuild);
      this.buildDataSource.update(editedBuild, 'update');
    }
  }

  handleValidation(string){
    let pass = false;  
    if (string && string.length > 0 && string.trim() != ''){
      pass = true;
    }
    return pass;
  }

  handleEditCancel() {
    this.setState({ editBuild: null, locationChanged: false, nameChanged: false, userAssignmentsChanged: false });
    dataModel.dataChanged = false;
    this.props.handleEditBuild(this.state.build, false);
  }

  handleBlur() {
    this.setState({ editBuild: null });
  }

  handlePrepareDrag(xPos, yPos) {
    this.dragElement = this.cardElement;
    this.startX = xPos;
    this.startY = yPos;
  }

  handleStartDrag(element) {
    if (!this.dragging && this.dragElement && this.dragElement == element && !this.dragObject) {
      this.dragging = true;
      let bodyElement = document.body;
      // if (this.props.dragParentId) {
      //   bodyElement = document.getElementById(this.props.dragParentId)
      // }
      this.dragObject = element.cloneNode(true);
      this.dragObject.style.position = 'absolute';
      this.dragObject.style.transform = 'rotate(-10deg)';
      this.dragObject.style.zIndex = 1000;
      this.dragObject.style.opacity = .8;
      const bodyRect = bodyElement.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      this.xPos = elementRect.left - bodyRect.left;
      this.yPos = elementRect.top - bodyRect.top;
      this.yOffset = this.startY - this.yPos;
      this.dragObject.style.top = this.yPos + 'px';
      this.dragObject.style.left = this.xPos + 'px';
      bodyElement.addEventListener('mousemove', this.handleDragging);
      bodyElement.addEventListener('mouseup', this.handleEndDragging);
      bodyElement.appendChild(this.dragObject);
    }
  }

  handleDragging(e) {
    let top = e.clientY - this.yOffset;

    this.dragObject.style.top = top + 'px';
    if (this.props.handleDragging) {
      this.props.handleDragging(this.state.build, this.xPos, top);
    }
  }

  handleEndDragging(e) {
    this.dragging = false;
    let bodyElement = document.body;
    // if (this.props.dragParentId) {
    //   bodyElement = document.getElementById(this.props.dragParentId)
    // }
    bodyElement.removeEventListener('mousemove', this.handleDragging);
    bodyElement.removeEventListener('mouseup', this.handleEndDragging);
    bodyElement.removeChild(this.dragObject);
    this.dragElement = null;
    this.dragObject = null;
    if (this.props.handleDropping) {
      let top = e.clientY - this.yOffset;
      this.props.handleDropping(this.state.build, this.xPos, top);
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    if (e.which == 1) {
      this.handlePrepareDrag(e.clientX, e.clientY);
      document.body.classList.add('no-select');
    }
  }

  handleMouseUp(e) {
    this.dragElement = null;
    document.body.classList.remove('no-select');
  }

  handleMouseMove(e) {
    e = this.fixupMouse(e);
    if (!this.dragging && e.which == 1) {
      if ((this.startX && Math.abs(this.startX - e.clientX) > 5) ||
        (this.startY && Math.abs(this.startY - e.clientY) > 5)) {
        this.handleStartDrag(this.cardElement);
      }
    }
  }

  createNotifyMemberArray(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-build-crud' + type + user.id} key={'user-avatar-build-crud' + user.id} user={user} small={true} />;
      });
    }
    else {
      return null;
    }
  }

  handleBuildOwnerSelection(type, option) {
    let { currentBuildOwners } = this.state;
    if (option && option.selected) {
      // adding the owner... make sure not already added
      if (!currentBuildOwners.find(bo => bo.id == option.user.id)) {
        currentBuildOwners.push(option.user);
        this.setState({ currentBuildOwners, userAssignmentsChanged: true });
      }
    }
    else if (option && !option.selected) {
      const foundBuildOwnerIndex = currentBuildOwners.findIndex(bos => bos.id == option.type);
      if (foundBuildOwnerIndex >= 0) {
        currentBuildOwners.splice(foundBuildOwnerIndex, 1);
        this.setState({ currentBuildOwners, userAssignmentsChanged: true });
      }
    }
  }

  handleBuildNotifySelection(type, option) {
    let { currentBuildNotify } = this.state;
    if (option && option.selected) {
      // adding the owner... make sure not already added
      if (!currentBuildNotify.find(bo => bo.id == option.user.id)){
        currentBuildNotify.push(option.user);
      }
      this.setState({ currentBuildNotify, userAssignmentsChanged: true });
    }
    else if (option && !option.selected) {
      const foundBuildNotifyIndex = currentBuildNotify.findIndex(bos => bos.id == option.type);
      if (foundBuildNotifyIndex >= 0) {
        currentBuildNotify.splice(foundBuildNotifyIndex, 1);
        this.setState({ currentBuildNotify, userAssignmentsChanged: true });
      }
    }
  }
  
  createBuildOwnerDisplay() {
    const { build } = this.state;

    let buildOwnerDisplay = <div className="build-owner" />;
    if (build && build.build_owners && build.build_owners.length > 0) {

      if (build.build_owners.length > 1) {
        const buildOwnerImages = this.createNotifyMemberArray(build.build_owners, 'build');
        const buildOwnerAvatars = (
          <div className={'member-display ' + (this.state.editBuild ? ' editing' : '')}>
            <div className="member-array">{buildOwnerImages}</div>
          </div>
        );

        buildOwnerDisplay =
          <div className="build-entry-field build-entry-field__build-owner">
            <div className="build-label">BUILD OWNER</div>
            <div className="user-images-list" onClick={this.handleAssignUsers}>
              {buildOwnerAvatars}
            </div>
          </div>;
      }
      else if (build.build_owners.length) {
        const buildOwner = build.build_owners[0];
        if (buildOwner.companies && buildOwner.companies.length > 0) {
          const userName = buildOwner.first_name + ' ' + buildOwner.last_name + ' | ' + buildOwner.companies[0].name;
          const longClassName = userName.length > 40 ? '--long' : '';
          buildOwnerDisplay = <div className={'build-owner' + (longClassName.length ? (' build-owner' + longClassName) : '')}>
            <UserAvatar user={buildOwner} />
            <div className="user-info">
              <div className={'user-name' + (longClassName.length ? ' user-name' + longClassName : '')} >
                {userName}
              </div>
              <div className="build-owner-title">Build Owner</div>
            </div>
          </div>;
        }
      }
    }

    return buildOwnerDisplay;
  }

  createBuildOwnerWatermark() {
    const { build } = this.state;

    if (build && build.build_owners && build.build_owners.length == 1) {
      const buildOwner = build.build_owners[0];
      //always assume we have the logo
      if (buildOwner.companies && buildOwner.companies[0] && buildOwner.companies[0].logo) {
        return (
          <div 
            className="watermark" 
            style={{ backgroundImage: `url("${buildOwner.companies[0].logo}")` }}
          >
          </div>
        );
      }
    }
    else if (build && build.build_owners && build.build_owners.length > 1) {
      //if build owners are all from the same company
      const buildOwnerCompanyIds = build.build_owners.map(BO => {
        if (BO.companies) {
          return BO.companies[0].id;
        }
        else {
          return null;
        }
      }
      );
      const allFromSameCompany = buildOwnerCompanyIds.every(id => id == buildOwnerCompanyIds[0]);
      if (allFromSameCompany && build.build_owners && build.build_owners.length > 0 && build.build_owners[0].companies && build.build_owners[0].companies.length > 0) {      
        return (
          <div 
            className="watermark" 
            style={{ backgroundImage: `url("${build.build_owners[0].companies[0].logo}")` }}
          >
          </div>
        );
      }
    }      
  }

  getLocations() {
    const { project } = this.props;
    const { locations, currentMarketId } = this.state;
    if (!locations || currentMarketId != project.market_id) {
      this.setState({ loadingLocations: true });
      this.locationsCollection = LocationsCollection.build(null, 12, null, this.props.currentUser.id, this.props.currentCompany.id, 'market_' + project.market_id, null, location_shallow, project.market_id);
      return this.locationsCollection.fetchCurrent(true, { clear: true, recordDescriptor: location_shallow }).then(currentData => {
        this.setState({ locations: currentData.locations, currentMarketId: project.market_id, loadingLocations: false, totalLocation: currentData.meta.total_records });
      });
    }
    else {
      return Promise.resolve(this.state.locations);
    }
  }

  createLocationOptions() {
    const { locations } = this.state;
    if (!locations || locations.length == 0) {
      return [];
    }
    const locationsList = locations.map(location => {
      let locationOption = { type: location.id, name: location.name, location: location };
      return locationOption;
    });
    return locationsList;
  }

  handleLocationSelection(type, option) {
    const { project } = this.props;
    const editBuild = Object.assign({}, this.state.editBuild, {});
    let locationChanged;
    if (project.location_id && project.location_id == option.location.id) {
      // project has location and selected option is the same...
      if (editBuild.location_id) {
        locationChanged = true;
        delete editBuild.location;
        editBuild.location_id = null;
      }
    } else {
      // either project does not have location or selected option is different
      if (option.location.id != editBuild.location_id) {
        locationChanged = true;
        editBuild.location = option.location;
        editBuild.location_id = option.location.id;
      }
    }
    this.setState({ locationChanged, editBuild });
    dataModel.dataChanged = locationChanged || this.state.nameChanged || this.state.userAssignmentsChanged;
  }

  handleLocationAdd(options){
    if(this.state.totalLocation > options.length){
      this.setState({ loadingLocations: true });
      this.locationsCollection.fetchNext().then((currentData)=>{
        console.log(currentData);
        this.setState({ locations: currentData.locations, loadingLocations: false });
      });
    }
  }

  render() {
    let { left, top, expanded, selected, project } = this.props;

    let { build, editBuild, loadingLocations, locationsList } = this.state;
    
    let loadingDots = null;
    if (!build) {
      loadingDots = <div className='loading-dots'>
        <LoadingDots smaller={true} />
      </div>;
    }

    let possibleNotifyUsers = project.users;

    const externalBuildOwner = !this.props.permissions.isSuperUser && (this.isBuildOwner &&
      BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(this.props.currentCompany, this.props.currentUser));

    if (externalBuildOwner) {
      possibleNotifyUsers = possibleNotifyUsers.filter(user => {
        return (user.role && (user.role.name == 'editor' || user.role.name == 'admin') && user.companies && user.companies.length > 0 &&
            (user.companies[0].id != this.props.currentCompany.id || this.props.currentUser.super_admin));
      });
    }

    let displayBuild = editBuild ? editBuild : build ? build : { id: this.props.buildId, name: '', tasks_completed_count: 0, tasks_count: 0, builds: [] };
    this.photoCount = 0;
    this.commentsCount = 0;

    const selectedClass = selected ? ' selected' : '';

    const classNames = 'build-detail-card ' + (editBuild ? ' editing' : '');

    let arrowClass = 'arrow-button ';  
    let expandedClass = '';
    let tooltipClass = 'tooltipText';
    if (expanded) {
      arrowClass += 'expanded';
      expandedClass = ' expanded';
      tooltipClass +=  ' expanded';
    }
    let menu;
    if (this.state.menu){
      menu = this.state.menu;
    }
    let buttonList = null;
    if (this.props.fromProjectTemplate) {
      buttonList =
      (<div className="build-button-list">
          <div className="button build-task-button">
            <img src={taskIconGray} alt="" />
          </div>
          <span className="build-label">{displayBuild.tasks_count}</span>
          <div className="button build-build-button">
            <img src={buildIconGray} alt="" />
          </div>
          <span className="build-label">{displayBuild.builds.length}</span>
        </div>
        );
    }
    else if (!editBuild) {
      let buildStyle;
      if (!displayBuild.builds || displayBuild.builds.length == 0) {
        buildStyle = { display: 'none' };
      }
      buttonList = <div className="build-button-list">
        <div className="button build-task-button">
          <img src={taskIconGray} alt="" />
        </div>
        <span className="build-label">{(displayBuild.tasks_completed_count ? displayBuild.tasks_completed_count : 0) + '/' + displayBuild.tasks_count}</span>
        <div className="button build-build-button" style={buildStyle}>
          <img src={buildIconGray} alt="" />
        </div>
        <span className="build-label" style={buildStyle}>{displayBuild.builds ? displayBuild.builds.length : 0}</span>
      </div>;
    }

    let moreButton = null;
    if (!editBuild && !this.props.quickAssignments && (this.props.permissions.canEditBuild || 
      (build && build.build_owners && build.build_owners.find(bowner => { return bowner.id == this.props.currentUser.id; })))) {
      moreButton = <div className='menu' id={'menu-' + displayBuild.id} onClick={this.handleMoreButton} />;
    }

    let expansionArrow = null;

    /** Feature removed temporarily because it confuses users. May revisit build nesting in the future */
    // if (!editBuild && (this.props.permissions.canEditBuild || (build && build.builds && build.builds.length > 0))) {
    //   expansionArrow = <div className="expand-click-area" onClick={this.handleExpandClick} >
    //     <img src={Arrow} className={arrowClass} alt="arrow" />
    //     <span className={tooltipClass}>Create a child build</span>
    //   </div>
    // }

    let buildLocationView = null;
    let buildNameView = null;
    let buildDateView = null;
    let action = null;
    let progressIndicator = null;
    const disabled = !(this.state.locationChanged || this.state.nameChanged || this.state.userAssignmentsChanged);

    if (editBuild) {

      let saveButton = <div className={'save-button' + (disabled ? ' disabled' : '')} onClick={!disabled ? this.handleBuildUpdate : null}>{this.textMap.save.toUpperCase()}</div>;
      let cancelButton = <div className='cancel-button' onClick={this.handleEditCancel}>{this.textMap.cancel.toUpperCase()}</div>;
      action = <div className='actions'>
        {cancelButton}
        {saveButton}
      </div>;

      let validated = this.handleValidation(editBuild.name);
      if (validated) {
        saveButton = <div className='save-button' onClick={this.handleBuildUpdate}>{this.textMap.save}</div>;
      }

      buildNameView = <div className="build-entry-field">
        <div className="build-label">Name</div>
        <div className="build-card-caption editing field">
          <Input className="build-input-field build-title-input" value={editBuild.name} onChange={this.handleNameChange} onKeyDown={this.handleKeyDown} ref={(element) => { this.titleInput = element; }} />
        </div>
      </div>;  
      const currentLocation = (editBuild && editBuild.location_id) ? editBuild.location : (project && project.location_id) ? project.location : null;
      buildLocationView = <div className="build-entry-field combo">
        <div className="build-label">Location</div>
        <div className="build-field">
          <ComboBox
            id={'locationPicker'}
            key={'locationPicker'}
            options={locationsList}
            showSearchBar={true}
            currentOption={currentLocation ? { type: currentLocation.id, name: currentLocation.name, location: currentLocation } : null}
            hasBorder={false}
            underlined={false}
            noneAvailabelText={loadingLocations ? this.textMap.noneSelected : undefined}
            width={230} 
            handleAddOption={this.handleLocationAdd}
            height={24} 
            small={true}
            displayFontStyle={{ fontSize: '12px' }}
            handleSelection={this.handleLocationSelection}
            placeHolderText={this.textMap.location}
            clearSelected={true}
            disabled={!locationsList || locationsList.length == 0}
          />
          { loadingLocations && <LoadingDots/> }
        </div>
      </div>;
    }
    else {
      const location = displayBuild && displayBuild.location_id ? displayBuild.location : project && project.location_id ? project.location : null;
      buildLocationView = <div className="build-card-location">
        <div className="build-card-location-text">
          Location ID: {location ? location.guid : ''}
        </div>
        <div className="build-card-location-text">
          Lat/Long: {location ? location.latitude : ''}/{location ? location.longitude : ''}
        </div>
      </div>;

      buildNameView = <div className="build-card-caption">
        {loadingDots}
        <span className={'card-title' + (displayBuild.builds && displayBuild.builds.length > 0 ? ' with-child-builds' : '')} title={displayBuild.name}>{displayBuild.name}</span>
      </div>;

      if (displayBuild.estimated_completion_date || displayBuild.actual_completion_date) {
        let overDue = '';
        let completionDate = formatDate(displayBuild.actual_completion_date ? displayBuild.actual_completion_date : displayBuild.estimated_completion_date);
        if (new Date(completionDate) < new Date()) {
          overDue = ' overdue';
        }
        buildDateView = <div className={'completion-date' + overDue}>{(displayBuild.actual_completion_date ? 'Completed On:': 'Estimated Completion: ') + completionDate}</div>;
      }

      const buildPercent = Math.round((displayBuild.tasks_completed_count ? displayBuild.tasks_completed_count : 0) * 100 / displayBuild.tasks_count);
      let backColor = buildPercent == 100 ? '#5DB348' : buildPercent > 0 ? '#f5a623' : '#9b9b9b';
      const measureStyle = { width: buildPercent + '%', borderBottom: '4px solid ' + backColor };

      progressIndicator = <div className="card-underline">
        <div className="card-measure-back"></div>
        <div className="card-measure" style={measureStyle}></div>
      </div>;
    }

    let notificationSelector = null;
    const notifyUsers = displayBuild.user_build_assignments ? displayBuild.user_build_assignments.filter(user_build_assignment => {
      if (user_build_assignment) {
        if (user_build_assignment.assignment_type == 'notify') {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }).map(ut => {
      return ut.user;
    }) : [];

    let notifyAvatars = null;
    if (notifyUsers.length > 0) {
      const notifyImages = this.createNotifyMemberArray(notifyUsers, 'notify');
      notifyAvatars = <div className={'member-display ' + (editBuild ? ' editing' : '')}>
            <div className="member-array">{notifyImages}</div>
          </div>;
    }

    let selectComboBox = null;
    if (editBuild && (this.isBuildOwner || this.props.permissions.canEditBuild)) {
      selectComboBox = <div className="build-field">
          <SelectUserComboBox
            key="notify-user"
            width={230}
            hasBorder={false}
            multiSelect={true}
            displayFontStyle={{ fontSize: '13px' }}
            height={24}
            selectedUsers={this.state.currentBuildNotify}
            menuBelow={true}
            useMultiTab={!externalBuildOwner}
            handleMultipleSelection={this.handleBuildNotifySelection}
            small={true}
            users={possibleNotifyUsers} 
            />
        </div>;

      notificationSelector = <div className="build-entry-field combo">
        <div className="build-label">Notify After Completion</div>
        {selectComboBox}
        <div className="user-images-list" onClick={this.handleAssignUsers}>
          {notifyAvatars}
        </div>
      </div>;
    }
    else {
      if (notifyUsers.length > 0) {
        notificationSelector =
          <div className="build-entry-field">
            <div className="build-label">NOTIFY AFTER COMPLETION</div>
            <div className="user-images-list" onClick={this.handleAssignUsers}>
              {notifyAvatars}
            </div>
          </div>;
      }
    }

    let buildOwnerDisplay = this.createBuildOwnerDisplay();

    if (editBuild) {
      let possibleBuildOwners = this.props.project.users ? this.props.project.users.filter(user => {
        if (externalBuildOwner) {
          if (user.companies[0].id != this.props.currentCompany.id || this.props.permissions.isSuperUser) {
            return true;
          }
          else{
            return false;
          }
        }
        else {
          if (!user.role) {
            if (user.company_vendor_users) {
              const vendor_user = user.company_vendor_users.filter(cvu => {
                return cvu.vendor_user.id == user.id;
              });
              if (vendor_user.length > 0) {
                return vendor_user[0].role && (vendor_user[0].role.name == 'editor' || vendor_user[0].role.name == 'admin');
              }
              return false;
            }
            return false;
          }
          else {
            return (user.role.name == 'editor' || user.role.name == 'admin');
          }
        }
      }) : [];

      let selectBuildOwnerComboBox = null;
      if (editBuild) {
        selectBuildOwnerComboBox = <div className="build-field">
          <SelectUserComboBox 
            key="build-owner-user" 
            width={230} 
            hasBorder={false} 
            multiSelect={true}
            height={24} 
            menuBelow={true} 
            useMultiTab={!externalBuildOwner} 
            small={true}
            displayFontStyle={{ fontSize: '13px' }}  
            handleMultipleSelection={this.handleBuildOwnerSelection}
            selectedUsers={this.state.currentBuildOwners}
            users={possibleBuildOwners} 
          />
        </div>;

        buildOwnerDisplay = <div className="build-entry-field combo">
          <div className="build-label">Build Owner</div>
          {selectBuildOwnerComboBox}
        </div>;
      }
    }

    let cardFooter = null;
    if (!editBuild) {
      cardFooter = (
        <div className="card-footer">
          <hr className={'separator ' + selectedClass + expandedClass} />
          {moreButton}
        </div>
      );
    }
    const buildContents = <div className={classNames}>
      {expansionArrow}
      <div className="card-top "> 
        {buildLocationView}
        <div className="build-name">
          {buildNameView}
          {buttonList}
        </div>
        {buildDateView}
        {buildOwnerDisplay}
        {notificationSelector}
      </div>
      {cardFooter}
      {action}
      {progressIndicator}
    </div>;
    const style = { width: 256, height: editBuild ? 274 : 150, left: left, top: top };
  
    return (
      <div>
        <div 
          key={'build-card-' + displayBuild.id} 
          id={'build-card-' + displayBuild.id}
          className={'build-detail-card-outer ' + (editBuild ? ' editing' : '') + (this.state.bulkAssignSelected ? ' ba-selected' : '')} 
          style={style}
          onMouseDown={this.handleMouseDown} 
          onMouseUp={this.handleMouseUp} 
          onClick={this.handleBuildSelection}
          onMouseMove={this.handleMouseMove} 
          ref={(element) => { this.cardElement = element; }}
        >
          {this.state.bulkAssignDisabled && <div className='ba-disabled-overlay'>{expansionArrow}</div>}
          { 
            !editBuild && this.createBuildOwnerWatermark()
          }
          {buildContents}
          {menu}        
        </div>
        {this.state.displayCopyPopout && 
          <CopyBuildPopout
            handleClosePopup={this.handleCopyPopupClose}
            displayCopyPopout={this.state.displayCopyPopout}
            build={displayBuild}
          />
        }  
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(BuildDetailCard);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/BuildDetailCard/index.js